/**
 * Importable api config.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import environment from 'js/config/environment';

const apiConfig = {
    dev: 'https://scalesology-ada-website-audit-portal.com/dev/',
    local: 'http://localhost:3000/dev/',
    prod: 'https://scalesology-ada-website-audit-portal.com/prod/',
    test: 'https://scalesology-ada-website-audit-portal.com/test/',
};

export const  domainOnly = apiConfig[environment].replace(/(\/(dev|prod|test)\/)$/i,"").replace(/3000$/i,"3333")

export const sessionKey = "scalesologyAdaSession"

export default apiConfig[environment];
